class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.productContainer = document.getElementById('cart-notification-product');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.deliveryObserver = null;
    this.deliveryNormalizationFrame = null;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.observeDeliveryNodes();
    this.normalizeDeliveryNodes();
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.observeDeliveryNodes();
      this.normalizeDeliveryNodes();

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  observeDeliveryNodes() {
    if (!this.productContainer) return;

    if (this.deliveryObserver) {
      this.deliveryObserver.disconnect();
    }

    this.deliveryObserver = new MutationObserver(() => this.scheduleDeliveryNormalization());
    this.deliveryObserver.observe(this.productContainer, { childList: true, subtree: true });
  }

  scheduleDeliveryNormalization() {
    if (this.deliveryNormalizationFrame) cancelAnimationFrame(this.deliveryNormalizationFrame);

    this.deliveryNormalizationFrame = requestAnimationFrame(() => {
      this.normalizeDeliveryNodes();
      this.deliveryNormalizationFrame = null;
    });
  }

  normalizeDeliveryNodes() {
    if (!this.productContainer) return;

    this.productContainer.querySelectorAll('.cart-item').forEach((item) => {
      let deliveryNode = this.findDeliveryNode(item);

      while (deliveryNode) {
        deliveryNode.remove();
        deliveryNode = this.findDeliveryNode(item);
      }
    });
  }

  findDeliveryNode(container) {
    const candidates = [...container.querySelectorAll('*')].filter((element) => {
      if (['SCRIPT', 'STYLE', 'IMG', 'A', 'BUTTON'].includes(element.tagName)) return false;
      return this.isDeliveryText(this.normalizeText(element.textContent));
    });

    if (!candidates.length) return null;

    const matchedOption = candidates.find((element) => element.classList.contains('product-option'));
    if (matchedOption) return matchedOption;

    let node = candidates[0];

    while (node.parentElement && node.parentElement !== container) {
      const parent = node.parentElement;
      const parentText = this.normalizeText(parent.textContent);
      const nodeText = this.normalizeText(node.textContent);

      if (parent.tagName === 'DL') break;

      if (parent.children.length === 1 || parentText === nodeText) {
        node = parent;
        continue;
      }

      break;
    }

    return node;
  }

  isDeliveryText(text) {
    return /estimated delivery|made just for you|arrives by/i.test(text);
  }

  normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }
}

customElements.define('cart-notification', CartNotification);
